import React from 'react';

import checkedFadedIcon from '@assets/img/icons/checked-faded.svg';
import errorSvg from '@assets/img/icons/error.svg';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  instructionFlowStepContainer: {
    ...common.flexColumn,
    marginTop: '1rem',
    '&$finished': {
      color: Color(theme.palette.primary.main).alpha(0.5).string(),
    },
    '&$current': {
      color: theme.palette.primary.dark,
    },
    '&$future': {
      color: theme.palette.grey[500],
    },
  },
  instructionFlowStepTitle: {
    ...common.flexInline,
    ...common.middleText,
    ...common.fontWeight600,
    marginBottom: 4,
  },
  instructionFlowStepItem: {
    ...common.smallerText,
    paddingLeft: 27,
    marginBottom: 2,
  },
  instructionFlowStepIconContainer: {
    marginRight: 4,
    position: 'relative',
    top: 2,
  },
  indexIcon: {
    ...common.flexCenter,
    fontSize: 10,
    color: theme.palette.background.paper,
    height: 16,
    width: 16,
    borderRadius: '50%',
    '$finished &': {
      backgroundColor: Color(theme.palette.primary.main).alpha(0.5).string(),
    },
    '$current &': {
      backgroundColor: theme.palette.primary.dark,
    },
    '$future &': {
      backgroundColor: theme.palette.grey[500],
    },
  },
  finished: {},
  current: {},
  future: {},
}));

export type InstructionFlowStatus = 'finished' | 'current' | 'future';

export interface InstructionFlowStepProps {
  index: number;
  status: InstructionFlowStatus;
  title: string;
  steps: string[];
  formSubmitted: boolean;
}

export const InstructionFlowStep: React.FC<InstructionFlowStepProps> = (props) => {
  const { index, status, title, steps, formSubmitted } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const isError = (status === 'current' || status === 'future') && formSubmitted;

  return (
    <div
      className={clsx(
        classes.instructionFlowStepContainer,
        classes[status],
        isError && classes.textErrorImportant,
      )}
    >
      <div className={classes.instructionFlowStepTitle}>
        <div className={classes.instructionFlowStepIconContainer}>
          {status === 'finished' && (
            <img src={checkedFadedIcon} alt="Finished" style={{ display: 'block' }} />
          )}
          {(status === 'current' || status === 'future') && !formSubmitted && (
            <div className={classes.indexIcon}>{index}</div>
          )}
          {isError && <img src={errorSvg} alt="Finished" style={{ display: 'block' }} />}
        </div>
        <div>{title}</div>
      </div>

      {steps.map((step, index) => (
        <div key={index} className={classes.instructionFlowStepItem}>
          {step}
        </div>
      ))}
    </div>
  );
};
